import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { accessRows, accessChecks } from '../../data/instantAccess';
export function InstantAccess() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-141" data-mp="39dq55tozbejc">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-142" data-mp="34bsggjxt7rj0">
        <SectionTag icon="📦" data-id="element-143" data-mp="30ays5pgggapl">Acceso inmediato</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-azul sm:text-4xl" data-id="element-144" data-mp="30cjljbr19nlv">
          Esto lo recibes en tu correo hoy mismo.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-145" data-mp="2qmgtpevnefp4">
          Material profesional descargable al instante, sin esperar envíos.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-2xl px-4 sm:px-6" data-id="element-146" data-mp="2gnrc7n7nyx9e">
        <ScrollHintTable minWidth="420px" data-id="element-147" data-mp="2gpc4t7af464m">
          <table className="w-full text-left text-sm" data-id="element-148" data-mp="2cle6uzwtx1d5">
            <thead data-id="element-149" data-mp="2cnqwlz8twg0r">
              <tr className="border-b border-gris-claro bg-bg-secondary text-xs uppercase tracking-wide text-muted" data-id="element-150" data-mp="35oooq6jz8bwp">
                <th className="px-5 py-3 font-semibold" data-id="element-151" data-mp="3afwy52lb3x9v">Formato</th>
                <th className="px-5 py-3 font-semibold" data-id="element-152" data-mp="3ah87dhxitx8d">Contenido</th>
                <th className="px-5 py-3 font-semibold" data-id="element-153" data-mp="2vs3ijhw80ura">Páginas</th>
              </tr>
            </thead>
            <tbody className="bg-white" data-id="element-154" data-mp="30pvaud0s2iw0">
              {accessRows.map((row, i) => <tr key={row.content} className={i !== accessRows.length - 1 ? 'border-b border-gris-claro' : ''} data-id="element-155" data-mp="3ofpp8z0qwfid" data-mpi={i}>
                  <td className="whitespace-nowrap px-5 py-4 text-azul-dark" data-id="element-156" data-mp="3tc6nwn5kmc9p">{row.format}</td>
                  <td className="px-5 py-4 text-muted" data-id="element-157" data-mp="3fe8c9pimwtxw">{row.content}</td>
                  <td className="whitespace-nowrap px-5 py-4 font-semibold text-naranja" data-id="element-158" data-mp="3jf1vi5l4tkkg">{row.pages}</td>
                </tr>)}
            </tbody>
          </table>
        </ScrollHintTable>

        <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-159" data-mp="281ps1vtab3yt">
          {accessChecks.map(check => <div key={check} className="flex items-center gap-2 text-sm text-gris-oscuro" data-id="element-160" data-mp="ehfp535e3vqh">
              <CheckIcon size={16} className="text-success" data-id="element-161" data-mp="9jmik906czpo" />
              {check}
            </div>)}
        </div>
      </div>
    </section>;
}